var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row align-items-center" },
    [
      _c(
        "p-input",
        {
          ref: "inputRef",
          attrs: {
            id: _vm.id,
            value: _vm.optionValue,
            name: _vm.name || _vm.id,
            disabled: _vm.disabled,
            readonly: _vm.readonly,
            type: _vm.inputType,
            color: _vm.inputColor,
            "data-lpignore": _vm.browserAutocomplete ? null : true,
            autocomplete: _vm.browserAutocomplete ? null : "off",
          },
          on: {
            focus: _vm.handleBaseFocus,
            blur: _vm.handleBaseBlur,
            change: _vm.handleBaseChange,
            input: _vm.handleBaseInput,
          },
          model: {
            value: _vm.valueModel,
            callback: function ($$v) {
              _vm.valueModel = $$v
            },
            expression: "valueModel",
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.hasTooltip
        ? _c("icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.right",
                value: {
                  title: _vm.tooltip,
                  html: true,
                  customClass: "my-tooltip-class",
                  variant: "light",
                },
                expression:
                  "{\n      title: tooltip,\n      html: true,\n      customClass: 'my-tooltip-class',\n      variant: 'light'\n    }",
                modifiers: { right: true },
              },
            ],
            staticClass: "text-primary",
            attrs: { name: "info-circle" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }